import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  flex-direction: column;
  gap: 15px;
  grid-column: span 12;
`;

export const Row = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const Index = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 20px;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
`;

export const Inputs = styled.div`
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 15px;
`;
